import {useEffect} from "react";
import {getCategoriesDataTC} from "../../state/reducers/categories-reducer";
import {useSelector} from "react-redux";
import {AppRootStateType} from "../../state/store";
import {ICategoriesResponseData} from "../../state/models/CategoriesResponse";
import {useAppDispatch} from "../useAppDispatch.ts";
import {useModal} from "../../context/ModalContext.tsx";
import {AvailableChannelsType} from "../../state/models/ChannelResponse.ts";
import {channelActions, setFilteredChannelsDataTC} from "../../state/reducers/channel-reducer.ts";
import {getChannelFilters, setChannelFilters} from "../../utils/Utils.ts";

const useAvailableChannelsPage = () => {
    const dispatch = useAppDispatch();

    const isLoading = useSelector((state: AppRootStateType) => state.channels.isLoading);
    const channelsData = useSelector<AppRootStateType, AvailableChannelsType>((state: AppRootStateType) => state.channels.availableChannels);
    const categoriesData = useSelector<AppRootStateType, ICategoriesResponseData[] | null>(state => state.categories.data);
    const filters = getChannelFilters();
    const toggleCheckBox = (id: string) => {
        dispatch(channelActions.toggleChannelChecked({id}))
    }
    const {openModal} = useModal();

    const openSearchModal = () => {
        openModal("SEARCH", {
            isOpen: true,
            searchType: 'createCampaign',
            onClose: () => {

            }
        });
    };
    useEffect(() => {
        if (!categoriesData) {
            dispatch(getCategoriesDataTC())
                .catch(err => console.log("Ошибка загрузки категорий:", err));
        }
    }, [categoriesData]);

    const getChannels = async () => {
        if (filters) {
            try {
                await dispatch(setFilteredChannelsDataTC(filters, true));
            } catch (err) {
                console.log("Ошибка при search канала:", err);
            }
        }else{
            try {
                await dispatch(setFilteredChannelsDataTC({}, true));
            } catch (err) {
                console.error("Ошибка при search канала:", err);
            }
        }
    };

    const resetForm = () => {
        setChannelFilters({});
        dispatch(setFilteredChannelsDataTC({}, true))
    }

    useEffect(() => {
        getChannels()
    }, [])

    return {
        isLoading,
        channelsData,
        openSearchModal,
        categoriesData,
        toggleCheckBox,
        resetForm,dispatch
    };
};

export default useAvailableChannelsPage;
